module.exports = __webpack_public_path__ + "static/media/icon7.06d50d4e.svg";